import React from "react";
import useStringInput, { StringInput } from "./string-input";
import { TForm, TInputElementProps, TInputProps } from "@/components/form/types";

type TEmailInput = string;
export const EmailInput = (props: TInputElementProps<TEmailInput>) => {
    return <StringInput {...props}/>
};

const useEmailInput = <T extends TEmailInput>(props: TInputProps<T>): TForm<TEmailInput> => {
    return useStringInput({
        id: "email",
        type: "email",
        ...props,
    })
}

export default useEmailInput;
